export default "__VITE_ASSET__Ca7P0Nle__"